module.exports = __webpack_public_path__ + "img/AccuFFRct_Series.921a37e0.png";